import { ReactElement, useMemo } from 'react'
import { SearchResultsComponentProps } from './props'
import SearchResultHeading from './SearchResultHeading'
import SearchResultText from './SearchResultText'
import { StyledSearchResults } from './styles'

const SearchResultsComponent = ({
    results,
    searchedText,
    t,
}: SearchResultsComponentProps): ReactElement => {
    const resultsDiv = useMemo(
        () =>
            results.map((result, i) => (
                <li key={i} onClick={result.onClick}>
                    <SearchResultHeading title={result.title} />
                    <SearchResultText
                        needle={searchedText}
                        text={result.text}
                        t={t}
                    />
                </li>
            )),
        [results, searchedText, t]
    )

    return (
        <StyledSearchResults>
            <ul>{resultsDiv}</ul>
        </StyledSearchResults>
    )
}

export default SearchResultsComponent

export { StyledSearchResults }
